<template>
    <div class="page main-signin-wrapper">
        <div class="row signpages text-center">
            <div class="col-md-12">
                <Loading v-if="showLoading" />
                <div class="card">
                    <div class="row row-sm">
                        <div class="col-lg-6 col-xl-5 d-none d-lg-block text-center bg-primary details">
                            <div class="login-side-box">
                                <img src="/assets/img/user.svg" class="ht-100 mb-0" alt="user">
                            </div>
                        </div>
                        <div class="col-lg-6 col-xl-7 col-xs-12 col-sm-12 login_form ">
                            <div class="container-fluid">
                                <div class="row row-sm">
                                    <div class="card-body mt-2 mb-2">
                                        <img src="assets/img/brand/logo.png" class=" d-lg-none header-brand-img text-left float-left mb-4" alt="logo">
                                        <div class="clearfix"></div>
                                        <form v-on:submit.prevent="submit">
                                            <h5 class="text-right mb-2">به حساب خود وارد شوید</h5>
                                            <div class="form-group text-right">
                                                <label>نام کاربری</label>
                                                <input class="form-control" dir="ltr" placeholder="نام کاربری خود را وارد کنید" type="tel" v-model="username" maxlength="11">
                                            </div>
                                            <div class="form-group text-right">
                                                <label>کلمه عبور</label>
                                                <input class="form-control" dir="ltr" placeholder="کلمه عبور خود را وارد کنید" type="password" v-model="password">
                                            </div>
                                            <div class="captcha-container mb-4">
                                                <img :src="captchaImage" class="captcha-image">
                                                <i class="si si-reload" data-toggle="tooltip" @click="createCaptcha" style="font-size: 30px;position: relative;top: 11px;margin-right: 10px;cursor: pointer" data-original-title="si-reload"></i>
                                            </div>
                                            <div class="form-group text-right">
                                                <label>کد امنیتی</label>
                                                <input type="text" class="form-control ltr-input" v-model="captcha" maxlength="5">
                                            </div>
                                            <button class="btn ripple btn-main-primary btn-block mb-3" :disabled="!username || !password || !captcha || captcha.length != 5">ورود</button>
                                            <router-link class="btn btn-link mb-0" :to="{name: 'resetPassword'}">فراموشی رمز عبور</router-link>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data(){
        return {
            showLoading: false,
            username: '',
            password: '',
            captcha: '',
            captchaImage: ''
        }
    },
    methods: {
        submit(){
            this.showLoading = true;
            const postedData = {
                Username: this.username,
                Password: this.password
            };
            this.$api.post('user/login',postedData,{headers: {captcha: this.captcha}}).then(({data}) => {
                if(data.status){
                    localStorage.setItem('agc-token',data.result.accessToken);
                    delete data.result.accessToken;
                    localStorage.setItem('user',JSON.stringify(data.result));
                    this.$toast.success('با موفقیت وارد سایت شدید');
                        setTimeout(() => {
                            window.location.href = '/';
                        },1500);
                }
            }).catch(({response}) => {
                response.data.errors.map(err => this.$toast.error(err.message));
            }).finally(() => {
                this.createCaptcha();
                this.showLoading = false;
            });
        },
        async createCaptcha(){
            let imgSrc = await this.generateCaptcha();
            this.captchaImage = imgSrc || this.captchaImage;
        }
    },
    created(){
        this.createCaptcha();
    }
}
</script>